import PropTypes from 'prop-types';
import React from 'react';
import FloatyBox from 'react-floatybox';
import Box from './Box';
import Text from './Text';

const PopoverBox = ({ text, bubbleWidth, align, alignInner, side, flip, children }) => {
  // const [showInfo, setShowInfo] = useState(false);

  const infoBubble = () => {
    return (
      <Box background="white" width={bubbleWidth} paddingX={5} paddingY={4}>
        <Box direction="column" display="flex">
          <Text size="sm">{text}</Text>
        </Box>
      </Box>
    );
  };

  return (
    <FloatyBox
      bubble={infoBubble}
      open="hover"
      side={side}
      align={align}
      alignInner={alignInner}
      flip={flip}
      trap={true}
    >
      {children}
    </FloatyBox>
  );
};

PopoverBox.propTypes = {
  text: PropTypes.string,
  bubbleWidth: PropTypes.number,
  align: PropTypes.string,
  alignInner: PropTypes.string,
  side: PropTypes.string,
  flip: PropTypes.bool
};

PopoverBox.defaultProps = {
  text: '',
  align: 'left',
  alignInner: 'left',
  side: 'top',
  bubbleWidth: 250,
  flip: true
};

export default PopoverBox;
